/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathIntegral = createReactComponent("outline", "math-integral", "IconMathIntegral", [["path", { "d": "M7 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2", "key": "svg-0" }]]);

export { IconMathIntegral as default };
//# sourceMappingURL=IconMathIntegral.mjs.map
